import { useMemo } from "react";

import Text from "@/shared-components/text/components/Text";
import Utils from "@/utils";

import "./styles/PriceTag.css";

/**
 * For styling the tag: you should only give height to the taghead and everythin will grow accordingly. You can do it using the className prop (it's assigned to the tag head element)
 */
export default function PriceTag({ currency, price }) {
  const priceTagText = useMemo(
    () => Utils.getArtworkPrice(price, currency),
    [price, currency]
  );

  const isMillionDollars = () => {
    return priceTagText.length > 8 ;
  };

  return (
    <>
      <div className="price-tag__container">
        <svg
          width="72"
          height="31"
          viewBox="0 0 72 31"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="price_tag"
        >
          <g opacity="0.23">
            <path
              d="M12.634 2.26099L2.27734 7.87057V23.1294L12.634 28.739H69.7234V2.26099H12.634ZM9.70715 19.6354C7.39469 19.6354 5.51312 17.767 5.51312 15.4702C5.51312 13.1734 7.39469 11.305 9.70715 11.305C12.0196 11.305 13.9017 13.1734 13.9017 15.4702C13.9017 17.767 12.0202 19.6354 9.70715 19.6354Z"
              
            />
          </g>
          <path
            d="M11.8667 0.100771L0.433655 6.29405C0.166364 6.43888 0 6.71696 0 7.01927V23.9813C0 24.2836 0.166364 24.5617 0.433655 24.7065L11.8667 30.8992C11.9887 30.9653 12.1257 31 12.2649 31H71.1676C71.6268 31 71.9994 30.63 71.9994 30.174V0.825991C71.9994 0.370044 71.6268 0 71.1676 0H12.2649C12.1257 0 11.9887 0.0346916 11.8667 0.100771ZM69.723 28.739H12.6337L2.27696 23.1294V7.87059L12.6337 2.26101H69.723V28.739Z"
           
          />
          <path
            d="M9.7077 11.3051C7.39524 11.3051 5.51367 13.1734 5.51367 15.4703C5.51367 17.7671 7.39524 19.6354 9.7077 19.6354C12.0202 19.6354 13.9023 17.7671 13.9023 15.4703C13.9023 13.1734 12.0207 11.3051 9.7077 11.3051ZM9.7077 17.3744C8.65074 17.3744 7.79064 16.5204 7.79064 15.4703C7.79064 14.4201 8.65074 13.5666 9.7077 13.5666C10.7647 13.5666 11.6253 14.4201 11.6253 15.4703C11.6253 16.5204 10.7652 17.3744 9.7077 17.3744Z"
            
          />
        </svg>
        <div className="price-tag__price"> <Text small={ !isMillionDollars(priceTagText) }>{priceTagText}</Text></div>
         
      </div>
    </>
  );
}
